var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMenuReverse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_menu_reverse",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M17.852.6H2.021A1,1,0,0,0,1,1.61H1A1,1,0,0,0,2.021,2.62H17.852c.511-.126,1.021-.631,1.021-1.01h0A1,1,0,0,0,17.852.6Z",
    transform: "translate(-.874 -.6)",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M16.478,5.8H7.01A1,1,0,0,0,6,6.81H6A1,1,0,0,0,7.01,7.82h9.468c.5-.126,1.01-.631,1.01-1.01h0A1.086,1.086,0,0,0,16.478,5.8Z",
    transform: "translate(-6 1.19)",
    fill: "#999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M1.125,4.277c0-.126.252-.2.126-.077h0L4.533,6.977c.126.126.126.379,0,.379h0l-3.156,2.9c-.126.126-.126.126-.252,0V4.277Z",
    transform: "translate(13.214 .775)",
    fill: "#999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M17.852,11H2.021A1,1,0,0,0,1,12.01H1a1,1,0,0,0,1.021,1.01H17.852c.511-.126,1.021-.5,1.021-1.01h0A1.092,1.092,0,0,0,17.852,11Z",
    transform: "translate(-.874 2.98)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMenuReverse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_menu_reverse.786a9546a81497f8f958d7c0339d75bd.svg";